define('lib/Podio.Organizations.Setup',['require','translate','underscore','jquery','lib/jquery/jquery.podioDropdown','lib/fileuploader/single','lib/Podio.FormValidation','lib/Podio.Routes','lib/Podio.Transport','lib/Podio.Router','lib/Podio.UI.Modal','lib/Podio.UI','lib/Podio.Event','lib/Podio.Event.UI'],function(require) {

  var t = require('translate');
  var _ = require('underscore');
  var $ = require('jquery');
  require('lib/jquery/jquery.podioDropdown');
  var FileUploaderSingle = require('lib/fileuploader/single');

  var formValidation = require('lib/Podio.FormValidation');
  var routes = require('lib/Podio.Routes');
  var transport = require('lib/Podio.Transport');
  var router = require('lib/Podio.Router');
  var modal = require('lib/Podio.UI.Modal');
  var ui = require('lib/Podio.UI');
  var podioEvent = require('lib/Podio.Event');
  var podioEventUI = require('lib/Podio.Event.UI');

  var imageTemplate =  _.template('<li><img src="<%= url %>" data-full-url="<%= fullUrl %>" /></li>');
  var elmBingImageUrl;

  var helpers = {
    searchForLogoes : function() {
      var elmOrgNameInput = $('#organization_name');
      var orgLogoList =  $('.org-setup-form ul.search-results');
      var orgName = elmOrgNameInput.val();

      if(orgName && orgName !== '') {
        var query = '{0} logo'.format(orgName);

          searchImage(query, function(imageList) {

          if(!imageList) {
            return false;
          }

          orgLogoList.empty();
          $('#organization_setup .logo-options .pick-text').show();

          if (imageList.length) {
            $('.org-setup-form .search-result-label').show();
          }
          else {
            $('.org-setup-form .search-result-label').hide();
          }

          _.each(imageList, function(image) {
            if(image) {
              var html = imageTemplate( {
                url     : image.proxyUrl,
                fullUrl : image.imageUrl
              });

              orgLogoList.append(html);
            }
          });

        });
      }
    }
  };

  function searchImage(query, callback) {

    var url = routes.organization_search_image_path({
      'query' : query
    });

    var req = transport.getJSON(url, {
      abortable : true
    });

    req.done(function(responseData) {
      if(responseData.data && responseData.data.result) {
        callback.call(this, responseData.data.result);
      }
    });

  }



  function onModalClose() {
    router.goToHashRoute('');
    return true;
  }

  function onOrganizationNameChanged(elmTarget, e) {
    helpers.searchForLogoes();
  }

  function onImageListImageClick(elmTarget, e) {

    var elmCurrentFile = $('#organization_setup .podio-uploader-file');
    elmCurrentFile.empty();
    elmCurrentFile.append($('<img />', { 'src' : elmTarget.attr('src')}));
    elmCurrentFile.append('<a class="remove remove-attachment-close-link"><span class="icon-16 icon-x-black2"></span></a>');

    elmBingImageUrl.val(elmTarget.attr('data-full-url'));
    $('.organization-logo input[type=hidden]').val('');
  }

  function onLaterButtonClick(elmTarget, e) {
    modal.hide();
  }

  function onSetupRouteInvoked() {
    showSetupModal();
  }

  function onInit() {
     if($('html').hasClass('logged-out') && $('.signup-org-setup').length ) {
       setupOrgSetupForm();
     }
  }

  function setupOrgSetupForm() {
    var elmSegmentSize = $('.org-setup-form .organization-segment-size');
    elmSegmentSize.podioDropdown();

    var elmUploadBox = $('.org-setup-form .organization-logo');
    elmBingImageUrl = $('#bing_image_url');

    var elmSearchResults = $('<ul/>', { 'class' : 'search-results' });
    elmUploadBox.find('.bd').append('<div class="hidden search-result-label">'+t("or select one below #org_phone")+'</div>').append(elmSearchResults);

    helpers.searchForLogoes();

    formValidation.init($('.org-setup-form'));

    var uploader = FileUploaderSingle.render(elmUploadBox, {
        onlyAllowImages: true
    });

    uploader.signals.onFileRemoved.add(function() {
      elmBingImageUrl.val('');
    });

    uploader.signals.onFileUploaded.add(function() {
      elmBingImageUrl.val('');
    });

    // If the name is prepopulated focus on it & start logo search
    var elmName = $('#organization_name');
    if (elmName.val() !== '') {
      elmName.select().focus().keyup();
    }

  }

  function showSetupModal(org_id) {
    // Hide account navigation if open
    $('#header-global .user-options-navigation').removeClass('active');

    var title = t('Setup organization #orgsetup');
    modal.showLoading(title);

    var url;
    if(org_id) {
      url = routes.edit_organization_setup_path(org_id);
    } else {
      url = routes.new_organization_setup_path();
    }

    transport.getJSON(url, { abortable: false, requestData: {} }, function(responseData) {
      modal.hide();
      modal.show(responseData.data.html, {
        title: title,
        hideOnOutsideClick: false,
        className : 'org-setup-modal',
        hideHandler: onModalClose
      });

      setupOrgSetupForm();
    });
  }

  function onFormSubmitted(elmTarget, e) {
    var elmButton = elmTarget.find('button, input.button');
    ui.disableButtonWithLoader(elmButton);
  }

  podioEvent.bind(podioEvent.Types.init, onInit);
  podioEventUI.bind('keyup', '#organization_name', _.debounce(onOrganizationNameChanged, 1000));
  podioEventUI.bind('click', '#organization_setup .search-results li img ', onImageListImageClick);
  podioEventUI.bind('click', '#organization_setup .footer .later', onLaterButtonClick);
  podioEventUI.bind('submit', '#organization_setup form', onFormSubmitted, true);

  router.addHashRoute("organization/setup", onSetupRouteInvoked);

  return {
    showSetupModal: showSetupModal
  };

});

